var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMailOrange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30.512,
    height: 28.934,
    viewBox: "0 0 30.512 28.934",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_51",
    x: 0,
    y: 0,
    width: 30.512,
    height: 28.934,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffb254",
    floodOpacity: 0.671
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Trac\\xE9_51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_51-2",
    "data-name": "Trac\\xE9 51",
    d: "M470.519-94.061c.021-.095.044-.189.063-.284a3.344,3.344,0,0,1,3.368-2.716q7.32-.017,14.639,0a3.339,3.339,0,0,1,3.372,2.707,3.306,3.306,0,0,1,.066.646q.008,2.73,0,5.461a.834.834,0,0,1-.819.882.827.827,0,0,1-.857-.822c-.011-.42,0-.84,0-1.26,0-1.344,0-2.688,0-4.064-.089.05-.159.085-.227.127q-3.485,2.165-6.968,4.332a3.319,3.319,0,0,1-3.126.324,4.264,4.264,0,0,1-.669-.347q-3.469-2.151-6.934-4.309c-.064-.04-.13-.076-.219-.128,0,.075-.008.127-.008.18q0,4.621,0,9.242a1.666,1.666,0,0,0,1.29,1.716,2.164,2.164,0,0,0,.54.054q7.246,0,14.492,0a1.681,1.681,0,0,0,1.764-1.257,2.551,2.551,0,0,0,.064-.456.835.835,0,0,1,.879-.8.834.834,0,0,1,.8.859,3.361,3.361,0,0,1-3.146,3.321q-.294.014-.588.014-7.12,0-14.24,0a3.468,3.468,0,0,1-2.2-.687,3.311,3.311,0,0,1-1.3-2.18,1.12,1.12,0,0,0-.04-.139Zm2.4-1c.084.055.141.094.2.13q3.564,2.217,7.126,4.437a1.786,1.786,0,0,0,2.063,0q3.557-2.228,7.126-4.437c.062-.039.122-.082.2-.134a1.754,1.754,0,0,0-1.128-.316H474.029A1.736,1.736,0,0,0,472.917-95.065Z",
    transform: "translate(-466.02 97.07)",
    fill: "#ffb254"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailOrange);
export default __webpack_public_path__ + "static/media/mail-orange.43cd341cd02766e6f8395dff2e67ccd7.svg";
export { ForwardRef as ReactComponent };